module.exports = __webpack_public_path__ + "img/位图备份_14.261aa388.jpg";